import { withPrefix } from 'gatsby';

var includesPathPrefix = function includesPathPrefix(location) {
  var re = new RegExp("^".concat(withPrefix('/')));
  return re.test(location);
};

var removePathPrefix = function removePathPrefix(location) {
  var re = new RegExp("^".concat(withPrefix('/').replace(/\/$/, '')));
  return location.replace(re, '');
};

var normalizeLocationPath = function normalizeLocationPath(location) {
  var normalizedPath = location.pathname.replace(/\/$/, '');

  if (includesPathPrefix(normalizedPath)) {
    normalizedPath = removePathPrefix(normalizedPath);
  }

  return {
    path: normalizedPath,
    pathWithHash: "".concat(normalizedPath).concat(location.hash)
  };
};

export { normalizeLocationPath };